module.exports = {
  "version": "0.24.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 121
// module chunks = 7